import { CountByKey } from "../../types/reports/report";

interface Props {
  title: string;
  data: CountByKey[];
  headerLabel: string;
}

const DataTable: React.FC<Props> = ({ title, data, headerLabel }) => {
  return (
    <div style={{ marginTop: "20px" }}>
      <h3>{title}</h3>
      <table width="100%" border={1} cellPadding={8}>
        <thead>
          <tr>
            <th>{headerLabel}</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.key}>
              <td>{row._id}</td>
              <td>{row.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
